import { FC } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

interface InactiveObjectBadgeProps {
  /** @deprecated Use variant="hanging" instead. Kept for existing call sites. */
  compact?: boolean;
  variant?: "hanging" | "inline";
  /** Horizontal offset for hanging ribbons (e.g. to align with a name after an icon). */
  left?: number | string;
  /** Override hanging top offset. Use 0 to glue the ribbon to a relative parent. */
  top?: number | string;
}

const InactiveObjectBadge: FC<InactiveObjectBadgeProps> = ({
  compact = false,
  variant,
  left = 0,
  top = "-20px"
}) => {
  const { t } = useTranslation();
  const label = t("common.inactive");
  const resolvedVariant = variant ?? (compact ? "hanging" : "inline");

  return (
    <Box
      title={label}
      aria-label={label}
      sx={{
        display: "inline-block",
        flexShrink: 0,
        boxSizing: "border-box",
        backgroundColor: "#646D7B",
        color: "#fff",
        padding: "4px 8px !important",
        borderRadius: "0px 0px 4px 4px",
        fontSize: "10px",
        fontWeight: 500,
        maxWidth: "max-content",
        textAlign: "center",
        lineHeight: 1.2,
        letterSpacing: "0.02em",
        whiteSpace: "nowrap",
        ...(resolvedVariant === "hanging"
          ? {
              position: "absolute",
              top,
              left
            }
          : {})
      }}
    >
      {label}
    </Box>
  );
};

export default InactiveObjectBadge;
